<template>
  <div class="order-first">
    <div class="crumbs-navigation">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/main' }">{{ $t('createQuotation.myQuotation') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('createQuotation.projectBasicInformation') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="flow-chart">
      <div class="el-steps el-steps--horizontal" style="justify-content: center;">
        <div class="el-step is-horizontal is-center" style="flex-basis: 15%; margin-right: 0px;">
          <div class="el-step__head is-finish">
            <div class="el-step__line" style="margin-right: 0px;">
              <i class="el-step__line-inner"
                 style="transition-delay: 0ms; border-width: 0px; width: 0%;"
              />
            </div>
            <div class="el-step__icon is-icon"><i class="el-step__icon-inner step1selected" /></div>
          </div>
          <div class="el-step__main">
            <div class="el-step__title is-finish">{{ $t('createQuotation.projectBasicInformation') }}</div>
            <div class="el-step__description is-finish" />
          </div>
        </div>
        <div class="el-step is-horizontal is-center" style="flex-basis: 15%; margin-right: 0px;">
          <div class="el-step__head is-process">
            <div class="el-step__line" style="margin-right: 0px;">
              <i class="el-step__line-inner"
                 style="transition-delay: -150ms; border-width: 0px; width: 0%;"
              />
            </div>
            <div class="el-step__icon is-icon" @click="jump2Step(secondProjectId,projectName)"><i class="el-step__icon-inner step2unselect" /></div>
          </div>
          <div class="el-step__main">
            <!--产品配置清单-->
            <div class="el-step__title is-process">{{ $t('createQuotation.productConfigurationList') }}</div>
            <div class="el-step__description is-process" />
          </div>
        </div>
        <div class="el-step is-horizontal is-center" style="flex-basis: 15%; margin-right: 0px;">
          <div class="el-step__head is-wait">
            <div class="el-step__line" style="margin-right: 0px;">
              <i class="el-step__line-inner"
                 style="transition-delay: -300ms; border-width: 0px; width: 0%;"
              />
            </div>
            <div class="el-step__icon is-icon" @click="jump3Step(secondProjectId,projectName)"><i class="el-step__icon-inner step3unselect" /></div>
          </div>
          <div class="el-step__main">
            <!--折扣信息-->
            <div class="el-step__title is-wait">{{ $t('createQuotation.discountInformation') }}</div>
            <div class="el-step__description is-wait" />
          </div>
        </div>
        <div class="el-step is-horizontal is-center" style="flex-basis: 15%; max-width: 25%;">
          <div class="el-step__head is-wait">
            <div class="el-step__line"><i class="el-step__line-inner" /></div>
            <div class="el-step__icon is-icon" @click="jump4Step(secondProjectId,projectName)"><i class="el-step__icon-inner step4unselect" /></div>
          </div>
          <div class="el-step__main">
            <div class="el-step__title is-wait">{{ $t('createQuotation.exportShare') }}</div>
            <div class="el-step__description is-wait" />
          </div>
        </div>
      </div>
    </div>
    <el-form :model="projectBaseInfo" :rules="rules" ref="projectBaseInfo">
      <div class="order-form">
        <div class="demo-input-suffix">
          <el-row :gutter="24">
            <!--报价单名称-->
            <el-col :span="6" :offset="3">
              <div class="grid-content t-r">
                <span class="rules-check">*</span>
                {{ $t('createQuotation.theNameList') }}
              </div>
            </el-col>
            <el-col :span="8">
              <el-form-item class="grid-content" prop="projectName">
                <el-input
                  :placeholder="$t('createQuotation.pleaseEnterNameList')"
                  v-model="projectBaseInfo.projectName"
                />
              </el-form-item>
            </el-col>
            <!--<el-col :span="6" class="p-0">-->
            <!--  <div class="grid-content t-l"><span>*</span></div>-->
            <!--</el-col>-->
          </el-row>
        </div>
        <!--新增,地区-->
        <div class="demo-input-suffix" style="margin-top: 30px;cursor: text" v-if="!IsChannel">
          <el-row :gutter="20">
            <el-col :span="6" :offset="3">
              <div class="grid-content t-r">
                <span class="t-l">*</span>
                {{ $t('createQuotation.sellsArea') }}
              </div>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="salesAreaName">
                <el-select
                  v-model="crmModel"
                  filterable
                  remote
                  :disabled="isCountriesDisable"
                  reserve-keyword
                  :remote-method="remoteMethod"
                  @change="selectCRM"
                  :placeholder="$t('createQuotation.enterRegionName')"
                  :loading="loading"
                >
                  <!--isChennel判断渠道用户和内部员工，渠道则为channelCountries赋值 -->
                  <template v-if="!IsChannel">
                    <el-option
                      v-for="item in AllCountries"
                      :key="item.id"
                      :label="item.englishShorterFormHand"
                      :value="item.twoLetterCode"
                    />
                  </template>
                  <template v-else>
                    <el-option
                      v-for="item in channelCountries"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"
                    />
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
            <!--<el-col :span="6">-->
            <!--  <div class="grid-content t-l"><span /></div>-->
            <!--</el-col>-->
          </el-row>
        </div>
        <div class="demo-input-suffix" style="margin-top: 30px" v-if="!IsChannel">
          <el-row :gutter="20">
            <el-col :span="6" :offset="3">
              <div class="grid-content t-r">{{ $t('createQuotation.customerName') }}</div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content ">
                <el-input
                  :placeholder="$t('createQuotation.pleaseInputClientName')"
                  v-model="projectBaseInfo.customerName"
                />
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content" />
            </el-col>
          </el-row>
        </div>
        <div class="demo-input-suffix" style="margin-top: 30px">
          <el-row :gutter="20">
            <el-col :span="6" :offset="3">
              <!--文件夹名称-->
              <div class="grid-content t-r">{{ $t('createQuotation.fileNameFolder') }}</div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content ">
                <el-popover
                  placement="bottom"
                  width="400"
                  trigger="click"
                  @show="getUserFolderTree"
                  v-model="popoverFlg"
                >
                  <div style="height: 350px;overflow-y: auto">
                    <el-tree :data="folderTree" default-expand-all :props="defaultProps" @node-click="handleNodeClick" />
                  </div>
                  <el-input
                    slot="reference"
                    v-model.trim="userFolderProjectFrom.folderName"
                    :placeholder="$t('createQuotation.fileNameFolder')"
                    readonly
                  />
                </el-popover>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content" />
            </el-col>
          </el-row>
        </div>
        <div class="demo-input-suffix" style="margin-top: 30px">
          <el-row :gutter="20">
            <el-col :span="6" :offset="3">
              <!--报价单备注-->
              <div class="grid-content t-r">{{ $t('createQuotation.quotationNote') }}</div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content ">
                <el-form-item class="grid-content" prop="projectRemark">
                  <el-input
                    type="textarea"
                    maxlength="200"
                    :autosize="{ minRows: 2, maxRows: 6}"
                    :placeholder="$t('createQuotation.pleaseEnterNoteInformation')"
                    v-model="projectBaseInfo.projectRemark" @input="descInput"
                  />
                </el-form-item>
                <span class="numberV">{{ txtVal }}/200</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content" />
            </el-col>
          </el-row>
        </div>
        <div class="demo-input-suffix" v-if="!IsChannel">
          <el-row :gutter="20">
            <el-col :span="6" :offset="3">
              <!--所属事业部-->
              <div class="grid-content t-r">{{ $t('createQuotation.belongGroup') }}</div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content">
                <el-input
                  :placeholder="$t('createQuotation.pleaseEnterNoteInformation')"
                  :disabled="true"
                  v-model="projectBaseInfo.deptName"
                />
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content" />
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="btn-p">
        <!--取消报价单-->
        <el-button @click="backList">{{ $t('createQuotation.cancelledReturnMyQuotation') }}</el-button>
        <el-button type="primary" @click="saveProjectBaseInfo" :disabled="isDisabled">{{ $t('createQuotation.nextConfigureProductList') }}</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import api from '../../api';
import step from '../../utils/step';
import { isChannel, getStore, setStore } from '@/utils/mUtils';
import { UserFolderTree } from '@/utils/userFolderTree';
export default {
  mixins: [step, UserFolderTree],
  name: 'CreatOrderFirst',
  data () {
    return {
      AllCountries:[], // 可选国家,初始数据
      channelCountries:[],//渠道用户可选国家,初始数据
      folderName: '', // 报价单基本信息
      isCountriesDisable:true, // 判断销售国家是否可编辑
      options: [],
      crmModel: '',
      secondProjectId: null,
      projectName: null,
      loading: false,
      list: [],
      projectBaseInfo: {
        projectId: '',
        projectName: '',
        deptName: '',
        crmProjectCode: '',
        crmProjectName: '',
        customerName: '',
        projectRemark: '',
        folderId: '',
        salesAreaName:"", // 选中区域的name
        salesAreaCode:'',// 选中区域的code
      },
      // 表单验证
      rules: {
        projectName: [{ required: true, message: this.$t('createQuotation.pleaseNameQuotation'), trigger: 'blur' }],
        projectRemark: [{ max: 200, message: this.$t('createQuotation.lengthExceedCharacters'), trigger: 'blur' }],
        salesAreaName: [{required: true, message:  this.$t('createQuotation.enterRegionName'), trigger: 'blur'}],
        salesAreaCode: [{max: 200, message: this.$t('createQuotation.lengthExceedCharacters'), trigger: 'blur'}]
      },
      // 是否是渠道
      IsChannel: true,
      txtVal: 0,
      isDisabled: false,
      isShowSelect: false// 是否显示会计主管的树状选择器
    };
  },
  methods: {
    // 初始化项目基本信息
    initializationObject () {
      this.secondProjectId = this.$route.query.secondProjectId;
      this.projectName = this.$route.query.projectName;
      if (this.secondProjectId != null && this.secondProjectId !== '') {
        api.selectProjectBaseInfoByProjectId({ params: { 'projectId': this.secondProjectId } }).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            let model = json.data;
            this.projectBaseInfo = model;
            // 可选择区域选中的回显字段
            this.crmModel = model.salesAreaName;
            this.userFolderProjectFrom.folderName = model.folderName;
            this.userFolderProjectFrom.folderId = model.folderId;
          } else {
            this.$message.error(json.err);
          }
        }).catch((e) => {
          this.$notify.error(this.$t('createQuotation.networkAnomaly'));
          console.error(e);
        });
      }
    },
    // 检索CRM项目名称
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true;
        api.getSellsAreaInfo({params:{englishFullNameios:query}}).then((res) => {
          let {status,err,data} = res.data;
          if(status === '200'){
            this.AllCountries=data;
            this.loading = false;
          }else{
            this.loading = false;
            this.$notify.error(err);
            console.log(err);
          }
        }).catch(err=>{
          console.log(err);
        });
      }
    },
    // 保存报价单基本信息
    saveProjectBaseInfo () {
      this.isDisabled = true;
      if (this.secondProjectId != null && this.secondProjectId !== '') {
        this.projectBaseInfo.projectId = this.secondProjectId;
      } else {
        this.projectBaseInfo.projectId = '';
      }
      this.$refs['projectBaseInfo'].validate(valid => {
        if (valid) {
          if (this.userFolderProjectFrom.folderName !== null && this.userFolderProjectFrom.folderName !== '') {
            this.projectBaseInfo.folderId = this.userFolderProjectFrom.folderId;
          }
           // 报价单名称 进行去除 首尾空格
          let newprojectName = this.projectBaseInfo.projectName.trim();
          //  新对象  接收对应的 值
          let newprojectBaseInfo= {
            projectId: this.projectBaseInfo.projectId,
            projectName: newprojectName, //报价单名称 进行去除 首尾空格   进行赋值
            deptName:  this.projectBaseInfo.deptName,
            crmProjectCode: this.projectBaseInfo.crmProjectCode,
            crmProjectName: this.projectBaseInfo.crmProjectName,
            customerName: this.projectBaseInfo.customerName,
            projectRemark: this.projectBaseInfo.projectRemark,
            folderId: this.projectBaseInfo.folderId,
            salesAreaName:this.projectBaseInfo.salesAreaName,
            salesAreaCode:this.projectBaseInfo.salesAreaCode,
          };

          api.saveProjectBaseInfo(newprojectBaseInfo)
            .then((res) => {
              let json = res.data;
              if (json.status === '200') {
                this.projectBaseInfo.projectName = newprojectName;
                this.projectBaseInfo.projectId = json.data;
                setStore('secondProjectName', newprojectName);
                this.$router.push({
                  name: 'CreatOrderSecond/second',
                  query: { projectId: this.projectBaseInfo.projectId, projectName: newprojectName }
                });
              }else if(json.status === '10002'|| json.status ==="10067"
              || json.status ==="10068" || json.status ==="10069" || json.status ==="10070" 
              || json.status ==="10071" || json.status ==="10072" || json.status ==="10073"
              ){
                this.$notify.error(json.err);
                this.isDisabled = false;
              } else {
                this.$notify.error(
                  json.data
                );
                this.isDisabled = false;
              }
            }).catch(() => {
              this.$notify.error(this.$t('createQuotation.networkAnomaly'));
              this.isDisabled = false;
            });
        } else {
          this.isDisabled = false;
          return false;
        }
      });
    },
    // 选择CRM时 自动带出客户名称
    selectCRM (crmCode) {
      if (crmCode !== '') {
        let list = this.AllCountries.filter(item => {
          return item.twoLetterCode === crmCode;
        });
        this.projectBaseInfo.salesAreaName = list[0].englishShorterFormHand;
        this.projectBaseInfo.salesAreaCode = list[0].twoLetterCode;
      }
    },
    // 获取当前用户信息
    getUserInfo () {
      let temp = getStore(`partnerFlg`);
      if (temp && temp !== '') {
        this.IsChannel = isChannel(temp);
      } else {
        api.getUserInfo().then((res) => {
          let json = res.data;
          if (json.status === '200' && json.data != null) {
            this.projectBaseInfo.deptName = json.data.deptName;
            this.IsChannel = isChannel(temp);
            console.log('temp2',this.IsChannel);
          } else {
            this.$notify.error(json.err);
          }
        }).catch((e) => {
          this.$notify.error(this.$t('createQuotation.networkAnomaly'));
        });
      };
      // IsChannel是渠道用户
      if(this.IsChannel){
        // 从vuex获取渠道用户销往地区信息
       this.channelCountries = JSON.parse(getStore(`channelCountries`)) ;
      // 判断销往地区唯一，直接赋值，并调用selectCRM方法查并赋值到saveProjectBaseInfo参数
      if(this.channelCountries != null && this.channelCountries.length == 1){
        this.crmModel = this.channelCountries[0].name;
        this.projectBaseInfo.salesAreaName = this.channelCountries[0].name;
        this.projectBaseInfo.salesAreaCode = this.channelCountries[0].code;
        }
      }
    },
    // 返回列表页面
    backList () {
      this.$router.push({ name: 'QuotationList' });
    },
    descInput () {
      this.txtVal = this.projectBaseInfo.projectRemark.length;
    },
    // input获取焦点事件,初始化树
    async focus (e) {
      let vm = this;
      vm.$refs.selectTree.filter('');
      vm.$refs.selectTree.setCurrentNode([]);
    },
    // 选择器的树节点
    filterNode (value, data) {
      if (!value) return true;
      if (!data.code_name) {
        data.code_name = data.chr_code + ' ' + data.chr_name;
      }
      return data.code_name.indexOf(value) !== -1;
    },

  },
  mounted () {
    this.initializationObject();
    this.getUserInfo();
    this.remoteMethod();
    // 控制销售地区是否可选
    this.isCountriesDisable = JSON.stringify(this.$route.query) !== '{}';
  },
  watch: {
    form: {// form.MANAGER_NAME变化时过滤节点
      handler (form) {
        if (this.isShowSelect) {
          this.$refs.selectTree.filter(form.MANAGER_NAME);
        }
      },
      deep: true// 深度监听，重要
    }
  }

};

</script>

<style scoped lang="scss">
.order-first{
  .el-step__icon.is-icon{
    width: 6rem !important;
  }
  .crumbs-navigation{
    padding-top: 15px;
  }
}
  .t-r {
    text-align: right;
  }
  .flow-chart {
    max-width: 1200px;
    min-width: 1024px;
    margin: 2rem auto 0;
  }

  .flow-chart img {
    width: 80%;
    text-align: center;
  }

  .order-first .el-step__title.is-process{
    font-weight: normal;
  }

  .order-first .order-form {
    margin-top: 6rem;
  }

  .order-first .demo-input-suffix .el-form-item {
    margin-bottom: 0 !important;
  }

  .order-first .demo-input-suffix {
    margin-top: 1.5rem !important;
  }

  .order-first .el-select .el-input__inner {
    cursor: text;
  }

  .el-breadcrumb__item .el-breadcrumb__inner {
    font-weight: normal;
    color: #36BAE2;
  }

  .el-breadcrumb__item:hover .el-breadcrumb__inner {
    color: #00b1e7;
  }

  .demo-input-suffix {
    margin-top: 0;
  }

  .demo-input-suffix input {
    height: 3.4rem;
    line-height: 3.4rem;
  }

  .el-select {
    width: 100%;
  }

  .demo-input-suffix .el-input__inner {
    width: 100%;
  }

  .demo-input-suffix .grid-content {
    line-height: 3.4rem;
  }

  .el-breadcrumb__item .el-breadcrumb__inner{
    font-weight: normal;
    color:#36BAE2;
  }

  .el-breadcrumb__item:hover .el-breadcrumb__inner{
    color:#36BAE2;
  }

  textarea:focus {
    border-color: #36BAE2 !important;
  }

  .btn-p {
    margin-top: 4rem;
  }

  .el-button--primary {
    color: #fff;
    background-color: #36BAE2 !important;
    border-color: #36BAE2 !important;
  }

  .el-button--primary:hover {
    color: #fff;
    background-color: #60c8e8 !important;
    border-color: #60c8e8 !important;
  }

  .el-button--default:hover {
    border: #36BAE2 !important;
    color: #36BAE2 !important;
    border: 1px solid #36BAE2 !important;
    background: rgba(54, 186, 222, 0.2);
  }

  .inline-input {
    width: 100%;
  }

  .el-autocomplete .el-input__inner {
    width: 100%;
    height: 3.4rem;
    line-height: 3.4rem;
    margin-left: 0;
    margin-bottom: 0.4rem;
  }

  .order-first .order-form .t-l {
    text-align: left;
    color: red;
    font-size: 2rem;
    position: absolute;
    top: 5px;
    right: 77px;
  }
.order-first .order-form .rules-check {
  text-align: left;
  color: red;
  font-size: 2rem;
  position: absolute;
  top: 5px;
  right: 110px;
}

  .order-first .grid-content {
    position: relative;
  }

  .order-first .numberV {
    position: absolute;
    right: 2%;
    bottom:2%;
    font-size: 12px;
    color: #333333;
  }
  .order-first .demo-input-suffix {
    margin-top: 2rem !important;
  }

  .order-first .demo-input-suffix .el-form-item {
    margin-bottom: 0.5rem!important;
  }

  .tree_class {
    border:1px solid #606266
  }

  @media screen and (max-width: 1366px) {
    .order-first .flow-chart img {
      width: 56%;
      text-align: center;
    }

    .order-first .btn-p {
      margin-top: 2rem;
    }

    .order-first .order-form {
      margin-top: 3rem;
    }
  }

  @media screen and (max-width: 1280px) {

    .order-first .order-form {
      margin-top: 2rem;
      font-size: 1.2rem;
    }

    .order-first .order-form .p-0 {
      padding-left: 0;
      font-size: 1.2rem !important;
    }

    .order-form .btn-p {
      margin-top: 4rem;
    }

    .order-form .btn-p .el-button {
      width: 25rem;
      height: 1rem !important;
      line-height: 0;
    }

  }

</style>
